import React from "react";

import localize from "lang/localize";

const Error404Page = props => (
  <div className="container verticalpadding">
    <div className="innerblock textcenter">
      <h6>{localize("error_404", props.language)}</h6>
    </div>
  </div>
);

export default Error404Page;
